import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 20.7302V9.93651C22 9.73937 21.9548 9.54494 21.868 9.36862C21.7812 9.19229 21.6552 9.03892 21.5 8.92063L12.75 2.25397C12.5336 2.08911 12.2705 2 12 2C11.7295 2 11.4664 2.08911 11.25 2.25397L2.5 8.92063C2.34476 9.03892 2.21875 9.19229 2.13197 9.36862C2.04518 9.54494 2 9.73937 2 9.93651V20.7302C2 21.0669 2.1317 21.3899 2.36612 21.6281C2.60054 21.8662 2.91848 22 3.25 22H20.75C21.0815 22 21.3995 21.8662 21.6339 21.6281C21.8683 21.3899 22 21.0669 22 20.7302Z",
		fill: "currentColor"
	})
});
export default SvgHomeFill;
